import { createContainer } from "unstated-next";

import useLocations from "./useLocations";

export const LocationsState = createContainer(useLocations);

LocationsState.Provider.displayName = "LocationsState";
